module.exports = __webpack_public_path__ + "static/media/background.81e66e22.jpg";